import { Routes } from '@angular/router';
import {
  CanActivateDriverOperations,
  CanActivateMessaging,
  CanActivateSiteConfiguration,
  CanActivateYardControl,
  CanActivateYardOperations,
  UserManagementGuard,
} from 'core/guards';
import { RootGuard } from 'core/guards/root.guard';
import { SuperAdminGuard } from 'core/guards/super-admin.guard';
import { HomeComponent } from './features/home/components/home/home.component';
import { MessagingComponent } from './features/messaging/components/messaging/messaging.component';
import { SupportComponent } from './features/support/components/support/support.component';
import { FeatureFlags } from '@feature-flags/feature-flags.const';
import { ContextService } from 'core/services/context.service';

export const rootRoutes: Routes = [
  {
    path: 'support',
    component: SupportComponent,
    pathMatch: 'full',
    canActivate: [RootGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'full',
    canActivate: [RootGuard],
  },
  {
    path: 'messages',
    component: MessagingComponent,
    loadChildren: () => import('./features/messaging/messaging.routes').then((m) => m.routes),
    canActivate: [RootGuard, CanActivateMessaging],
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

export const routeFactory = (contextSvc: ContextService): Routes => {
  return [
    {
      path: 'sites',
      loadChildren: () => import('./features/site-configuration/site-configuration.routes').then((m) => m.routes),
      canActivate: [RootGuard, CanActivateSiteConfiguration],
    },
    {
      path: 'yard-control',
      loadChildren: () => {
        return contextSvc.isFeatureFlagEnabled(FeatureFlags.UseYardOpsApi)
          ? import('./features/_merge/yard-control/yard-control.routes').then((m) => m.routes)
          : import('./features/yard-control/yard-control.routes').then((m) => m.routes);
      },
      canActivate: [RootGuard, CanActivateYardControl],
    },
    {
      path: 'yard-operations',
      loadChildren: () => {
        return contextSvc.isFeatureFlagEnabled(FeatureFlags.UseYardOpsApi)
          ? import('./features/_merge/yard-operations/yard-operations.routes').then((m) => m.routes)
          : import('./features/yard-operations/yard-operations.routes').then((m) => m.routes);
      },
      canActivate: [RootGuard, CanActivateYardOperations],
    },
    {
      path: 'driver/yard-operations',
      loadChildren: () => {
        return contextSvc.isFeatureFlagEnabled(FeatureFlags.UseYardOpsApi)
          ? import('./features/_merge/yard-operations-driver/yard-operations-driver.routes').then((m) => m.routes)
          : import('./features/yard-operations-driver/yard-operations-driver.module').then((m) => m.routes);
      },
      canActivate: [RootGuard, CanActivateDriverOperations],
    },
    {
      path: 'user-management',
      loadChildren: () => import('./features/user-management/user-management.routes').then((m) => m.routes),
      canActivate: [RootGuard, UserManagementGuard],
    },
    {
      path: 'admin-panel',
      loadChildren: () => import('./features/admin-panel/admin-panel.routes').then((m) => m.routes),
      canActivate: [RootGuard, SuperAdminGuard],
    },
    ...rootRoutes,
  ];
};
